import { render, staticRenderFns } from "./MatchStats.vue?vue&type=template&id=f8ebcc1a&scoped=true&"
import script from "./MatchStats.vue?vue&type=script&lang=js&"
export * from "./MatchStats.vue?vue&type=script&lang=js&"
import style0 from "./MatchStats.vue?vue&type=style&index=0&id=f8ebcc1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ebcc1a",
  null
  
)

export default component.exports